module.exports = __webpack_public_path__ + "static/media/XVe.5fcf74ae.png";